import { api } from "_endpoints/api";
import http from "../axios";

//add tradesman
export function updateUser(id, data) {
  return http.post(api.user.getUpdateUrl, id, data);
}

export async function unSubscribe(email) {
  return await http.post(api.user.unsubscribe, { email });
}

export async function getUserDetailsByEmail(email) {
  return await http.get(api.user.getUserDetailsByEmail(email));
}

export async function updateProfileImage(email, payload) {
  return await http.post(api.user.updateProfileImage(email), payload);
}

export async function updateUserDetails(email, payload) {
  return await http.post(api.user.updateUserDetails(email), payload);
}

export async function updateContactDetails(payload) {
  return await http.post(api.user.updateContactDetails, payload);
}

export async function getLandlord() {
  return await http.get(api.user.getLandlord);
}

export async function checkInvitation(payload) {
  return await http.post(api.user.checkInvitation, payload);
}

export async function getUserAccountCustomisationSettings() {
  return await http.get(api.user.getAccountCustomisationSettings);
}

export async function updateCustomAccountSettings(payload) {
  return await http.post(api.user.updatecustomAccountSettings, payload);
}

export async function updateTicketingCustomSettings(payload) {
  return await http.post(api.user.updateTicketingCustomSettings, payload);
}

export async function getTicketingCustomSettings() {
  return await http.get(api.user.getTicketingCustomSettings);
}

export async function getPushNotificationPreferences() {
  return await http.get(api.user.getPushNotificationPreferences);
}

export async function updatePushNotificationPreferences(payload) {
  return await http.put(api.user.updatePushNotificationPreferences, payload);
}

export async function getDetails() {
  return await http.get(api.user.getDetails);
}

export async function validateTicketToken(payload) {
  return await http.post(api.user.validateTicketToken, payload);
}

/** Register FCM device token (authenticated). */
export async function registerPushToken(payload) {
  return await http.post(api.user.pushTokenRegister, payload);
}

/** Remove FCM device token (logout / permission revoked). */
export async function removePushToken(payload) {
  return await http.post(api.user.pushTokenRemove, payload);
}

export async function getOnboardingGuideStatus() {
  return await http.get(api.user.onboardingGuideStatus);
}

export async function consumeOnboardingGuide(source) {
  return await http.post(api.user.onboardingGuideConsume, { source });
}

export async function getOnboardingGuideContent() {
  return await http.get(api.user.onboardingGuideContent);
}

export async function getOnboardingGuideStep(stepIndex) {
  return await http.get(api.user.onboardingGuideStep(stepIndex));
}

export async function dismissOnboardingGuide() {
  return await http.post(api.user.onboardingGuideDismiss);
}

export async function checkInvitationTradesperson(payload) {
  return await http.post(api.user.checkInvitationTradesperson, payload);
}

